import Api from "../../../lib/api";

export const DONOR_PROFILE_MAP_DATA = {
  start: "fetch_start/donor_profile_map_data",
  end: "fetch_end/donor_profile_map_data",
  success: "fetch_success/donor_profile_map_data",
  failed: "fetch_failed/donor_profile_map_data",
  reset: "reset/donor_profile_map_data",
};

export const donorProfileMapDataFetchStart = () => ({
  type: DONOR_PROFILE_MAP_DATA.start,
});

export const donorProfileMapDataFetchEnd = () => ({
  type: DONOR_PROFILE_MAP_DATA.end,
});

export const donorProfileMapDataFetchSuccess = (data) => ({
  type: DONOR_PROFILE_MAP_DATA.success,
  data,
});

export const donorProfileMapDataFetchFailed = (error) => ({
  type: DONOR_PROFILE_MAP_DATA.failed,
  error,
});

export const donorProfileMapDataReset = () => ({
  type: DONOR_PROFILE_MAP_DATA.success,
});

export const getDonorProfileMapData = (year, donor) => (dispatch) => {
  dispatch(donorProfileMapDataFetchStart());
  const filterYear = year || "";
  const filterDonor = donor || "";
  if (year !== "")
    return Api.get(Api.API_DONOR_PROFILE_MAP_DATA(filterYear, filterDonor))
      .then((response) => {
        dispatch(donorProfileMapDataFetchEnd());
        dispatch(donorProfileMapDataFetchSuccess(response.data));
      })
      .catch((exception) => {
        dispatch(donorProfileMapDataFetchEnd());
        dispatch(donorProfileMapDataFetchFailed(exception));
      });
  else {
    dispatch(donorProfileMapDataFetchEnd());
    dispatch(donorProfileMapDataFetchFailed());
  }
};

export const resetDonorProfileMapData = (dispatch) => {
  dispatch(donorProfileMapDataReset());
};



// WEBPACK FOOTER //
// ./shared/actions/mapActions/getDonorProfileMapData.js